import { pages } from '../routes/config';

const links = [
  {
    labelPath: 'pagesNames.about',
    href: pages.ABOUT,
    external: false,
  },
  {
    labelPath: 'pagesNames.policy',
    href: 'https://www.maccosmetics.de/privacy-policy',
    external: true,
  },
  {
    labelPath: 'pagesNames.terms',
    href: `https://www.maccosmetics.de/terms-use`,
    external: true,
  },
  {
    labelPath: 'pagesNames.faq',
    href: pages.FAQ,
    external: false,
  },
];

export default links;
